export const COUNCIL_SESSION_ITEM_OUTCOME_LABELS = {
    adoptee: 'Adoptée',
    rejetee: 'Rejetée',
    retiree: 'Retirée de l\'ordre du jour',
    reportee: 'Reportée',
};
export const LEGAL_DEADLINE_KIND_LABELS = {
    deliberations_list: 'Liste des délibérations',
    minutes: 'Procès-verbal',
};
export const LEGAL_ACT_TYPE_LABELS = {
    deliberation: 'Délibération',
    arrete: 'Arrêté municipal',
    decision_maire: 'Décision du maire',
    avis_enquete: 'Avis d\'enquête publique',
    marche_public: 'Marché public',
    urbanisme: 'Acte d\'urbanisme',
    pv_seance: 'Procès-verbal de séance',
    liste_deliberations: 'Liste des délibérations',
    autre: 'Autre acte administratif',
};
export const PUBLICITY_MODE_LABELS = {
    affichage: 'Affichage',
    papier: 'Publication sur papier',
    electronique: 'Publication électronique',
};
/** Types d'actes cochés par défaut « soumis à transmission en préfecture », modifiable par l'agent. */
export const LEGAL_ACT_TRANSMISSION_DEFAULT = {
    deliberation: true,
    arrete: true,
    decision_maire: true,
    avis_enquete: false,
    marche_public: true,
    urbanisme: true,
    pv_seance: false,
    liste_deliberations: false,
    autre: false,
};
/** Forme habituelle d'un identifiant @ctes : département-SIREN-date-numéro-nature. */
export const ACTES_AR_ID_PATTERN = /^\d{2}[0-9AB]-\d{9}-\d{8}-[A-Za-z0-9_]{1,15}-[A-Z]{2}$/;
export const LEGAL_ACT_NATURE_LABELS = {
    reglementaire: 'Réglementaire',
    ni_reglementaire_ni_individuel: 'Ni réglementaire ni individuel',
    individuel: 'Individuel',
};
/** Nature proposée à la création selon le type, modifiable par l'agent. */
export const LEGAL_ACT_DEFAULT_NATURE = {
    deliberation: 'ni_reglementaire_ni_individuel',
    arrete: 'reglementaire',
    decision_maire: 'ni_reglementaire_ni_individuel',
    avis_enquete: 'ni_reglementaire_ni_individuel',
    pv_seance: 'ni_reglementaire_ni_individuel',
    liste_deliberations: 'ni_reglementaire_ni_individuel',
};
export const LEGAL_ACT_STATUS_LABELS = {
    draft: 'Brouillon',
    published: 'Publié',
    unpublished: 'Dépublié',
    archived: 'Archivé',
};
export const COUNCIL_SESSION_TYPE_LABELS = {
    ordinaire: 'Ordinaire',
    extraordinaire: 'Extraordinaire',
    huis_clos: 'Huis clos',
};
export const LEGAL_ACT_AUDIT_ACTION_LABELS = {
    created: 'Création',
    updated: 'Modification',
    published: 'Publication',
    unpublished: 'Dépublication',
    archived: 'Archivage',
    document_replaced: 'Document remplacé',
    deleted: 'Brouillon supprimé',
    transmission_updated: 'Transmission en préfecture',
    document_added: 'Document ajouté',
    document_removed: 'Document retiré',
    document_redacted: 'Occultation',
};
